import '@vendor/ownbit/wp-module-responsivenavigation/js/jquery.ResponsiveNavigation.js'
import '@vendor/ownbit/wp-module-responsiveFooter/js/jquery.FooterWidgetFolder.js'
import './modules/search.js'
import './modules/jquery.Accordion.js'
import './modules/menu.js'

import './modules/TooltipComponent.js'
import './modules/ProductSwiperComponent.js'

import $ from 'jquery'

$(function () {
  /*******************************
   * Slider customizations
   * TODO: is messy, fix if time left
   ******************************/

  $('.OBSlider').each(function () {
    let slider = $(this).data('OBSlider')
    slider.options.slideChange = function (slider, $slides, currentIndex) {
      let _this = this
      this.$indicatorControl.html('')

      let createIndicatorHandler = function (i) {
        return function () {
          _this.showSlide(i)
        }
      }

      for (let i = 0; i < $slides.size(); i++) {
        let $indicator
        if (currentIndex === i) {
          $indicator = $(/*html*/ `
            <span class="indicator">
              <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(-58.000000, -894.000000)" stroke="#FFFFFF" stroke-width="3">
                    <g transform="translate(0.000000, 207.000000)">
                      <circle cx="67" cy="696" r="7"></circle>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            `)
          $indicator.addClass('indicator-active')
        } else {
          $indicator = $(/*html*/ `
            <span class="indicator">
              <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(-146, -896)" fill="#FFFFFF">
                    <g transform="translate(0, 207)">
                      <circle cx="153" cy="696" r="7"></circle>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            `)
        }
        $indicator.click(createIndicatorHandler(i))
        _this.$indicatorControl.append($indicator)
      }
    }
    slider.showSlide(0)
  })
})

/*******************************
 * Desktop search
 ******************************/

$('.control-toggle-desktop-search').click(function () {
  let $searchForm = $('.desktop-search .search-form')
  let $input = $searchForm.find('input')
  $searchForm.animate(
    {
      width: 'toggle',
    },
    function () {
      /*
       * Focus the textbox after
       */
      $input.focus()
    },
  )
})

/*******************************
 * Menu Landscaoe ontap
 ******************************/

function isiPhone() {
  return (
    //Detect iPhone
    //let isiPad = navigator.userAgent.match(/iPad/i) != null;
    navigator.platform.indexOf('iPhone') != -1 ||
    //Detect iPod
    navigator.platform.indexOf('iPad') != -1
  )
}

$(function () {
  if (isiPhone()) {
    let aClickHandler = function () {
      window.location = $(this).attr('href')
    }

    let $navElemns = $('.nav-toggle-container > li')

    $navElemns.on('click', function (e) {
      if (Modernizr.mq('only screen and (min-width: 992px)')) {
        let $this = $(this)

        $navElemns.blur()
        $this.focus()

        $ul = $this.find('> ul')

        let $as = $this.find('a')
        $as.off('click', aClickHandler)

        if ($ul.is(':visible')) {
          e.preventDefault()
          e.stopPropagation()

          $as.on('click', aClickHandler)
        } else {
        }

        /*
         * Remove the click listener
         * at blur
         */
        $this.on('blur', function () {
          $as.unbind('click', aClickHandler)
        })
      }
    })
  }
})

/*******************************
 * Init Alpine.js
 ******************************/

import './alpine/init.js'

let init = () => {
  Alpine.start()
  document.body.classList.remove('not-initialized')
}

// Await the 'wpce:after-element-scripts' event to avoid starting Alpine before
// element-specific groundwork (e.g. element-specific Alpine plugins) is laid
document.addEventListener(
  'wpce:after-element-scripts',
  () => {
    // Initializing Alpine is quite a bit of CPU work.
    // If the browser supports it, we delay its initialization
    // until there are free CPU cycles, with a maximum of 3 seconds.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(init, { timeout: 3000 })
    } else {
      init()
    }
  },
  { once: true },
)
